import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import TopNav from "../components/TopNav";
import BottomNav from "../components/BottomNav";
import Footer from "../components/footer/Footer";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { MdCall, MdEmail } from "react-icons/md";
import { BsTelephone, BsSend } from "react-icons/bs";
import PN from "../makkaanpages/images/peaknest-CP.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";

import AKR from "../makkaanpages/images/Peaknest1.jpg";
import Location from "../makkaanpages/images/Peaknest2.png";
import Amenities from "../makkaanpages/images/Peaknest3.png";

import PN1 from "../makkaanpages/images/Peaknest5.jpg";
import PN2 from "../makkaanpages/images/Peaknest4.jpg";
//import PN3 from "../makkaanpages/images/Peaknestc2.jpg";
import PNPP from "../makkaanpages/images/PEAKNEST-PP.png";

import developerlogo from "../makkaanpages/images/images.png";
import makkaanLogo from "../makkaanpages/images/makkaanlogo.png";
import paymentplan from "../makkaanpages/pdf/peak-nest-ppt.pdf";
import paymentplanupdated from "../makkaanpages/pdf/peak nest payment plan 2025  april  .pdf";

import Slider from "react-slick";

import "./CustomArrow.css";
import "../App.css";
import api_url from "../ApiUrl";
import axios from "axios";

import { SampleNextArrow, SamplePrevArrow } from "./CustomArrow";
import lightgreen from "../makkaanpages/images/lightgreen.jpg";

function Peaknest() {
  const formRef = useRef();
  const paymentRef = useRef();

  const [isSticky, setIsSticky] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [paymentTop, setPaymentTop] = useState(0);
  const [formHeight, setFormHeight] = useState(0);
  const [modalImages, setModalImages] = useState([]);

  const [isFixed, setIsFixed] = useState(false);

  const [stickyLeft, setStickyLeft] = useState(0);

  const [modalImage, setModalImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedd, setIsExpandedd] = useState(false);

  const [isExpandedMarketedBy, setIsExpandedMarketedBy] = useState(false);
  const [isExpandedDevelopedBy, setIsExpandedDevelopedBy] = useState(false);

  const toggleMarketedBy = () => {
    setIsExpandedMarketedBy((prev) => !prev);
  };

  const toggleDevelopedBy = () => {
    setIsExpandedDevelopedBy((prev) => !prev);
  };

  const fullText = `Makkaan.com has launched Avenue 18, a premier commercial
  project redefining investment opportunities in DHA Phase 1, Islamabad. Perfectly positioned on the DHA Phase 4 main
  link road, this architectural marvel is located in the heart of a rapidly expanding commercial hub, making it an
  ideal destination for businesses and investors. With its three open sides, 7-story design, and a stunning 20-ft
  atrium, Avenue 18 stands as a beacon of modern architecture and functionality. Offering premium spaces
  for shops, food courts, and offices, the project boasts a grand entrance, high-speed elevators, and state-of-the-art
  facilities to meet the demands of dynamic business environments. Avenue 18 by Makkaan.com, ensures a
  future-ready investment with guaranteed on-time delivery in 3 years and a flexible 4-year payment plan.`;

  const [navOffset, setNavOffset] = useState(0);
  const [hasReachedPayment, setHasReachedPayment] = useState(false);

  useEffect(() => {
    if (formRef.current) {
      setFormHeight(formRef.current.offsetHeight);
    }
  }, [formRef.current]);

  const getImageUrlForStage = (stageId) => {
    const selectedStage = stages.find((stage) => stage.id === stageId);
    if (selectedStage && selectedStage.images.length > 0) {
      return selectedStage.images[0]; // show first image for now
    }
    return "";
  };
  const handleImageClick = (stageId) => {
    const selectedStage = stages.find((stage) => stage.id === stageId);
    if (selectedStage) {
      setModalImages(selectedStage.images);
      setShowModal(true);
    }
  };

  const stages = [
    { id: 1, label: "Dec 2024", images: [AKR] },
    { id: 2, label: "Mar 2025", images: [PN2] },
  ];

  const [activeStage, setActiveStage] = useState(stages[stages.length - 1].id);

  const overviewRef = useRef(null);
  const developmentRef = useRef(null);
  const locationRef = useRef(null);
  const navRef = useRef(null);

  const scrollPosition = window.scrollY || window.pageYOffset;
  const formOffset = formRef.current?.offsetTop || 0;
  const paymentBottom =
    paymentRef.current?.offsetTop + paymentRef.current?.offsetHeight || 0;

  // Scroll handler for the enquiry form
  const overviewTop = 300;

  useEffect(() => {
    const updatePositions = () => {
      if (paymentRef.current && formRef.current) {
        setPaymentTop(paymentRef.current.offsetTop);
        setFormHeight(formRef.current.offsetHeight);
      }
    };

    updatePositions();
    window.addEventListener("resize", updatePositions);
    return () => window.removeEventListener("resize", updatePositions);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || window.pageYOffset;

      if (!formRef.current || !paymentRef.current || !overviewRef.current)
        return;

      const formHeight = formRef.current.offsetHeight;
      const formOffset = formRef.current.offsetTop;
      const paymentBottom =
        paymentRef.current.offsetTop + paymentRef.current.offsetHeight;
      const overviewTop = overviewRef.current.offsetTop;

      // If above form or overview section
      if (scrollPosition < overviewTop) {
        setIsSticky(false);
        setIsBottom(false);
        return;
      }

      // Sticky state
      if (scrollPosition > 50 && scrollPosition + formHeight < paymentBottom) {
        if (!isSticky) {
          const rect = formRef.current.getBoundingClientRect();
          setStickyLeft(rect.left);
        }
        setIsSticky(true);
        setIsBottom(false);
      }
      // Reached bottom of Payment section
      else if (scrollPosition + formHeight >= paymentBottom) {
        setIsSticky(false);
        setIsBottom(true);
      }
      // Default fallback
      else {
        setIsSticky(false);
        setIsBottom(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial check

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isSticky]);

  // Scroll handler for the navigation bar
  useEffect(() => {
    window.scrollTo(0, 0);
    if (navRef.current) {
      setNavOffset(navRef.current.offsetTop);
    }

    const handleNavScroll = () => {
      if (window.pageYOffset >= navOffset) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleNavScroll);
    return () => {
      window.removeEventListener("scroll", handleNavScroll);
    };
  }, [navOffset]);

  const shortenedText = `${fullText.slice(0, 300)}...`; // Limit to 150 characters

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const handleNext = () => {
    const currentIndex = stages.findIndex((stage) => stage.id === activeStage);
    const nextIndex = (currentIndex + 1) % stages.length;
    setActiveStage(stages[nextIndex].id);
  };

  const handlePrev = () => {
    const currentIndex = stages.findIndex((stage) => stage.id === activeStage);
    const prevIndex = (currentIndex - 1 + stages.length) % stages.length;
    setActiveStage(stages[prevIndex].id);
  };

  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const settingss = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleScrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  const submit = () => {
    const fullName = document.getElementById("fullName");
    const phone = document.getElementById("phone");
    const email = document.getElementById("email");

    if (!fullName?.value?.trim()) {
      toast.error("Please enter your name");
      return;
    }
    if (!phone?.value?.trim()) {
      toast.error("Please enter your phone number");
      return;
    }

    const params = {
      fullName: fullName.value.trim(),
      phone: phone.value.trim(),
      email: email?.value?.trim() || "",
    };

    axios
      .post(`${api_url}contact/create`, params)
      .then((res) => {
        if (res.data.status === "ok") {
          toast.success("Your message was submitted successfully!");
          // Clear form fields
          fullName.value = "";
          phone.value = "";
          if (email) email.value = "";

          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          toast.error(res.data.message || "Error submitting your message");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("An unexpected error occurred. Please try again later.");
      });
  };
  return (
    <>
      <Helmet>
        <title>Peak Nest Residency Murree - Payment Plan</title>
        <meta
          name="description"
          content="
Find affordable apartments at Peak Nest Murree – modern living spaces with scenic views, ideal for holiday homes and investment in the heart of Murree. "
        />
      </Helmet>
      <div className="position-relative view_property">
        <ToastContainer />
        <div
          className=" position-fixed w-100"
          style={{ zIndex: "999999", marginTop: "-8em" }}
        >
          <TopNav />
          <BottomNav />
        </div>

        <div style={{ marginTop: "8em", zIndex: "0" }}>
          <div className="container mb-3">
            <div className="d-flex align-items-center justify-content-between flex-wrap ">
              <div className="d-flex align-items-center mt-2">
                <img
                  src={developerlogo} // or use the imported image
                  alt="Project Logo"
                  style={{
                    width: "70px",
                    height: "70px",
                    objectFit: "contain",
                    marginRight: "1em",
                  }}
                />
                <div>
                  <h4
                    className="mb-0"
                    style={{ fontSize: "25px", color: "#4db749", zIndex: 10 }}
                  >
                    Peak Nest Murree
                  </h4>
                  <small className="text-muted">Mussiari Murree.</small>
                </div>
              </div>
              <div>
                <h5 className="mb-0">
                  <small className="text-muted">
                    STARTING FROM <br />
                  </small>
                  <span style={{ fontSize: "22px" }}>PKR </span>

                  <strong
                    style={{ fontSize: "25px", color: "#4db749", zIndex: 10 }}
                  >
                    {" "}
                    2,118,825 to 33,750,000
                  </strong>
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-3 mb-3">
          <div className="row">
            <div className="col-sm-8">
              <Slider {...settings}>
                <div>
                  <img
                    loading="lazy"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    src={AKR}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: "pointer",
                    }}
                  />
                </div>

                <div>
                  <img
                    loading="lazy"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    src={Amenities}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: "pointer",
                    }}
                  />
                </div>

                <div>
                  <img
                    loading="lazy"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    src={Location}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: "pointer",
                    }}
                  />
                </div>

                <div>
                  <img
                    loading="lazy"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    src={Amenities}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: "pointer",
                    }}
                  />
                </div>

                <div>
                  <img
                    loading="lazy"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    src={PN1}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: "pointer",
                    }}
                  />
                </div>

                <div>
                  <img
                    loading="lazy"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    src={PN2}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* <div>
                  <img
                    loading="lazy"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    src={PN3}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: "pointer",
                    }}
                  />
                </div> */}
              </Slider>
            </div>
            <div className="col-sm-4">
              <img
                className="imagedata"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                src={Location}
                loading="lazy"
                style={{ width: "100%", height: "auto", cursor: "pointer" }}
              />
              <img
                className="imagedata"
                id="overview"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                src={Amenities}
                style={{
                  width: "100%",
                  height: "auto",
                  paddingTop: "0.89em",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
        </div>

        <div className="container d-flex">
          <a href="#profile-tab">
            <i
              className="bi bi-camera mx-2"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              onClick={() => document.getElementById("profile-tab").click()}
              style={{ cursor: "pointer" }}
            ></i>
          </a>
          <a>
            <i
              className="bi bi-geo-alt mx-2"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              onClick={() => document.getElementById("contact-tab").click()}
              style={{ cursor: "pointer" }}
            ></i>
          </a>
        </div>

        <div
          class="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          style={{ zIndex: "100000000000" }}
        >
          <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">
                  PeakNest
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home"
                      type="button"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                    >
                      Images
                    </button>
                  </li>

                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      type="button"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      Videos
                    </button>
                  </li>

                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="contact-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#contact"
                      type="button"
                      role="tab"
                      aria-controls="contact"
                      aria-selected="false"
                    >
                      Map
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="slider-container p-5">
                      <Slider {...settingss}>
                        <div>
                          <img
                            loading="lazy"
                            src={AKR}
                            alt="Avenue18-p1"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <img
                            loading="lazy"
                            src={Location}
                            alt="Avenue18"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={Amenities}
                            alt="Avenue18-map"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={PN1}
                            alt="Avenue18-map"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={PN2}
                            alt="Avenue18-map"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        {/* <div>
                          <img
                            loading="lazy"
                            src={PN3}
                            alt="Avenue18-map"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div> */}
                      </Slider>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="p-5"></div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="contact"
                    role="tabpanel"
                    aria-labelledby="contact-tab"
                  >
                    <div className="p-5">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.647102671812!2d73.39469917442348!3d33.872984527176584!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfd99ce01d0aa9%3A0xe4c0908c01502006!2sPeak%20Nest%20Murree!5e0!3m2!1sen!2s!4v1736159045407!5m2!1sen!2s"
                        width="100%"
                        height="400px"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Div  */}

        <div className="fixed-bar">
          <button type="button" class="btn btn-primary">
            Contact Us
          </button>

          <a href="+923311111049">
            <button className="col-sm-4 btn fixed-button">
              <i class="bi bi-telephone"></i> Call
            </button>
          </a>
          <a href="http://wa.me/+923311111045">
            <button className="col-sm-4 btn fixed-button">
              <i class="bi bi-whatsapp"></i>
            </button>
          </a>
        </div>

        {/* Tabs bars  */}
        <div
          ref={navRef}
          className={`mid-nav ${isFixed ? "fixed" : ""}`}
          id="midNav"
          style={{ zIndex: "10000000" }}
        >
          <div className="nav-buttons-container py-3">
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("overview")}
            >
              Overview
            </button>

            <button
              className="nav-button"
              onClick={() => handleScrollToSection("development")}
            >
              Development Updates
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("location")}
            >
              Location
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("payment")}
            >
              Payment Plans Floor Plans
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("FAQ's")}
            >
              FAQ's
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("marketed")}
            >
              Developed By
            </button>
          </div>
        </div>
        <div className="container mt-3" id="overview">
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container" ref={overviewRef}>
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Overview
                    </h2>

                    {/* <div>
                      <p style={{ paddingTop: "1em" }}>
                        {isExpandedd ? fullText : shortenedText}
                      </p>
                      <button
                        onClick={() => setIsExpandedd(!isExpandedd)}
                        style={{
                          color: "#4db749",
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                      >
                        {isExpandedd ? "Show Less" : "Show More"}
                      </button>
                    </div> */}

                    <li className="d-flex justify-content-between align-items-center p-3">
                      {/* Left Section: Icon + Text */}
                      <div className="d-flex align-items-center">
                        <i
                          className="bi bi-geo-alt me-2"
                          style={{
                            fontSize: "20px",
                            color: "#4db749",
                            zIndex: 10,
                          }}
                        ></i>
                        <div className="d-flex flex-column">
                          <span style={{ fontSize: "14px" }}>Location</span>
                          <div className="fw-bold">Mussiari Murree.</div>
                        </div>
                      </div>

                      {/* Right Section: Icon + Text */}
                      <div className="d-flex align-items-center">
                        <i
                          className="bi bi-person me-2"
                          style={{
                            fontSize: "20px",
                            color: "#4db749",
                            zIndex: 10,
                          }}
                        ></i>
                        <div className="d-flex flex-column">
                          <span style={{ fontSize: "14px" }}>Developer</span>
                          <div className="fw-bold">7 Sky</div>
                        </div>
                      </div>
                    </li>

                    <style>
                      {`
  .mid-nav {
    z-index: 100 !important;
  }
  .fixed-bar {
    z-index: 100 !important;
  }
  .position-fixed {
    z-index: 100 !important;
  }
  
  .accordion-item {
  border: 1px solid #dee2e6 !important;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
  overflow: hidden; /* Keeps border-radius on child elements */
}

/* Header styling */
.accordion-button {
  border-bottom: 1px solid #dee2e6 !important;
  background-color: white;
}

/* Active header */
.accordion-button:not(.collapsed) {
  
  background-color: rgb(218, 237, 215) !important;
}

/* Remove double border when collapsed */
.accordion-button.collapsed {
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

/* Remove the border from accordion-body */
.accordion-body {
background-color: rgb(218, 237, 215) !important;
  border: none !important;
}
  
  `}
                    </style>

                    <div className="accordion mt-5" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button collapsed d-flex align-items-center w-100"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                            style={{
                              backgroundColor: "",
                              paddingTop: "40px",
                              paddingBottom: "40px",
                              border: "none",
                            }}
                          >
                            {/* Left Section: Icon + Text */}
                            <div className="d-flex align-items-center">
                              <i
                                className="bi bi-shop me-2"
                                style={{
                                  fontSize: "20px",
                                  color: "#4db749",
                                  zIndex: 10,
                                }}
                              ></i>
                              <span className="fw-bold">One Bed</span>
                            </div>

                            {/* Spacer to push content to the right */}
                            <div className="flex-grow-1"></div>

                            {/* Right Section: Price + Dropdown Icon */}
                            <div className="d-flex align-items-center">
                              <span
                                className="text-muted me-1"
                                style={{ fontSize: "12px" }}
                              >
                                PKR
                              </span>
                              <span className="fw-bold me-1">
                                13,391,994 -
                                <span className="mobile-break">
                                  <br />
                                </span>{" "}
                                9,624,555
                              </span>
                            </div>
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div
                                className="d-flex flex-column"
                                style={{ backgroundColor: "white" }}
                              >
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  First Floor One Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 957 - 822</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                11,514,433 - 13,391,994
                              </div>
                            </li>

                            <li
                              className="d-flex justify-content-between align-items-center p-3 shadow-sm rounded mt-4 mb-4"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Second Floor One Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 656 - 957</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                7,866,052 - 13,391,994
                              </div>
                            </li>
                            <li
                              className="d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Third Floor One Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 822 - 969</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                9,339,910 - 13,391,994
                              </div>
                            </li>

                            <li
                              className="d-flex justify-content-between align-items-center p-3 mt-4 mb-4  shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Fourth Floor One Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 743 - 969</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                9,660,136 - 13,391,994
                              </div>
                            </li>
                            <li
                              className="d-flex justify-content-between align-items-center p-3 mt-4 mb-4  shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Fifth Floor One Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area:743 to 969 </span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                9,624,555 - 13,391,994
                              </div>
                            </li>

                            <li
                              className="d-flex justify-content-between align-items-center p-3   shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Sixth Floor One Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area:822 to 970 </span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                19,660,136 - 13,391,994
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button  d-flex align-items-center w-100 collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-controls="collapseTwo"
                            style={{
                              paddingTop: "40px",
                              paddingBottom: "40px",

                              border: "none",
                            }}
                          >
                            {/* Left Section: Icon + Text */}
                            <div className="d-flex align-items-center">
                              <i
                                className="bi bi-building me-2"
                                style={{
                                  fontSize: "20px",
                                  color: "#4db749",
                                  zIndex: 10,
                                }}
                              ></i>
                              <span className="fw-bold">Studio</span>
                            </div>

                            {/* Spacer to push content to the right */}
                            <div className="flex-grow-1"></div>

                            {/* Right Section: Price + Arrow */}
                            <div className="d-flex align-items-center">
                              <span
                                className="text-muted me-1"
                                style={{ fontSize: "12px" }}
                              >
                                PKR
                              </span>
                              <span className="fw-bold me-3">
                                6,453,775 - 7,997,426
                              </span>
                            </div>
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <li
                              className=" d-flex justify-content-between align-items-center p-3 mb-4 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  First Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 519 -623</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                6,223,870 - 7,997,426
                              </div>
                            </li>

                            <li
                              className=" d-flex justify-content-between align-items-center p-3 mt-4 mb-4 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Second Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 543 -694</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                7,062,751 - 8,325,863
                              </div>
                            </li>

                            <li
                              className=" d-flex justify-content-between align-items-center p-3 mt-4 mb-4 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Third Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 538 - 547</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                6,991,590 - 7,116,122
                              </div>
                            </li>

                            <li
                              className=" d-flex justify-content-between align-items-center p-3 mt-4 mb-4 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Fourth Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 538 - 583</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                6,991,590 - 7,578,670
                              </div>
                            </li>

                            <li
                              className=" d-flex justify-content-between align-items-center p-3 mt-4 mb-4 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Fifth Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 538 - 583</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                6,991,590 - 7,578,670
                              </div>
                            </li>

                            <li
                              className=" d-flex justify-content-between align-items-center p-3 mt-4 mb-4 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Sixth Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 538 - 583</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                6,991,590 - 7,578,670
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button  d-flex align-items-center w-100 collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsePent"
                            aria-controls="collapsePent"
                            style={{
                              paddingTop: "40px",
                              paddingBottom: "40px",

                              border: "none",
                            }}
                          >
                            {/* Left Section: Icon + Text */}
                            <div className="d-flex align-items-center">
                              <i
                                className="bi bi-building me-2"
                                style={{
                                  fontSize: "20px",
                                  color: "#4db749",
                                  zIndex: 10,
                                }}
                              ></i>
                              <span className="fw-bold">Pent house</span>
                            </div>

                            {/* Spacer to push content to the right */}
                            <div className="flex-grow-1"></div>

                            {/* Right Section: Price + Arrow */}
                            <div className="d-flex align-items-center">
                              <span
                                className="text-muted me-1"
                                style={{ fontSize: "12px" }}
                              >
                                PKR
                              </span>
                              <span className="fw-bold me-3">33,750,000</span>
                            </div>
                          </button>
                        </h2>
                        <div
                          id="collapsePent"
                          className="collapse"
                          aria-labelledby="headingPent"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <li
                              className=" d-flex justify-content-between align-items-center p-3  mb-4 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Seventh Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Gross Area: 2250</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                33,750,000
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div
                ref={formRef}
                className={`sticky-form d-none d-lg-block ${
                  isSticky ? "fixed" : ""
                } ${isBottom ? "bottom" : ""}`}
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  padding: "1.2em",
                  paddingTop: "0.8em",
                  paddingBottom: "1.5em",
                  borderRadius: "8px",
                  width: "100%",
                  maxWidth: "22em",
                  boxSizing: "border-box",
                  position: isSticky
                    ? "fixed"
                    : isBottom
                    ? "absolute"
                    : "relative",

                  // Lock the top and left when sticky
                  top: isSticky
                    ? "10em"
                    : isBottom
                    ? `${paymentBottom - formHeight}px`
                    : "auto",
                  left: isSticky ? stickyLeft : "auto", // <-- Add this line

                  transform: "none",
                  willChange: "transform",
                }}
              >
                <h4
                  className="text-center text-black mb-2"
                  style={{ fontSize: "16px", fontWeight: "600" }}
                >
                  MAKE AN ENQUIRY
                </h4>
                <div className="text-center mb-2">
                  <a
                    href="tel:03311111049"
                    className="text-decoration-none d-block"
                  >
                    <button
                      className="btn btn-success w-100 py-1"
                      style={{
                        backgroundColor: "#00B53F",
                        border: "none",
                        height: "32px",
                      }}
                    >
                      <BsTelephone className="me-2" />
                      Call Now
                    </button>
                  </a>
                  <div
                    className="text-center my-1"
                    style={{ fontSize: "13px", color: "#666" }}
                  >
                    or
                  </div>
                </div>
                <div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Your Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fullName"
                      placeholder="How should we address you?"
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        height: "32px",
                        fontSize: "13px",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Phone Number *
                    </label>
                    <div className="input-group">
                      <span
                        className="input-group-text"
                        style={{
                          backgroundColor: "#fff",
                          fontSize: "13px",
                          border: "1px solid #ddd",
                          borderRight: "none",
                          width: "75px",
                          height: "35px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src="https://flagcdn.com/w20/pk.png"
                          alt="PK"
                          style={{ width: "18px" }}
                          className="me-1"
                        />
                        +92
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        placeholder="Your phone number"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderLeft: "none",
                          height: "35px",
                          fontSize: "13px",
                          borderRadius: "0 4px 4px 0",
                          flex: "1",
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Email Address (Optional)
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Your best email address?"
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        height: "32px",
                        fontSize: "13px",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                  <button
                    className="btn btn-success w-100 py-1 mt-2"
                    onClick={submit}
                    style={{
                      backgroundColor: "#00B53F",
                      border: "none",
                      height: "35px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      fontWeight: "500",
                    }}
                  >
                    <BsSend className="me-2" />
                    Request Call
                  </button>
                  <div
                    className="text-center text-muted mt-2"
                    style={{ fontSize: "11px" }}
                  >
                    By submitting this form, you agree to{" "}
                    <a href="#" className="text-primary text-decoration-none">
                      Terms of Use
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Form Button */}
            <div
              className="d-lg-none fixed-bottom bg-white p-3"
              style={{ boxShadow: "0 -2px 10px rgba(0,0,0,0.1)" }}
            >
              <button
                className="btn btn-success w-100"
                style={{ backgroundColor: "#00B53F" }}
                onClick={() => setShowFormModal(true)}
              >
                Make an Enquiry
              </button>
            </div>

            {/* Mobile Form Modal */}
            <Modal
              show={showFormModal}
              onHide={() => setShowFormModal(false)}
              centered
              style={{ zIndex: "9999999" }}
              dialogClassName="modal-on-top"
              contentClassName="position-relative"
            >
              <Modal.Header
                closeButton
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  border: "none",
                  paddingTop: "1.2em",
                  paddingBottom: "0",
                }}
              >
                <Modal.Title
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  MAKE AN ENQUIRY
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  padding: "1.2em",
                }}
              >
                <div>
                  <div className="text-center mb-2">
                    <a
                      href="tel:03311111049"
                      className="text-decoration-none d-block"
                    >
                      <button
                        className="btn btn-success w-100 py-1"
                        style={{
                          backgroundColor: "#00B53F",
                          border: "none",
                          height: "32px",
                        }}
                      >
                        <BsTelephone className="me-2" />
                        Call Now
                      </button>
                    </a>
                    <div
                      className="text-center my-1"
                      style={{ fontSize: "13px", color: "#666" }}
                    >
                      or
                    </div>
                  </div>
                  <div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Your Name *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="fullName"
                        placeholder="How should we address you?"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          height: "32px",
                          fontSize: "13px",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Phone Number *
                      </label>
                      <div className="input-group">
                        <span
                          className="input-group-text"
                          style={{
                            backgroundColor: "#fff",
                            fontSize: "13px",
                            border: "1px solid #ddd",
                            borderRight: "none",
                            width: "75px",
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src="https://flagcdn.com/w20/pk.png"
                            alt="PK"
                            style={{ width: "18px" }}
                            className="me-1"
                          />
                          +92
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="phone"
                          placeholder="Your phone number"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderLeft: "none",
                            height: "32px",
                            fontSize: "13px",
                            borderRadius: "0 4px 4px 0",
                            flex: "1",
                          }}
                        />
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Email Address (Optional)
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Your best email address?"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          height: "32px",
                          fontSize: "13px",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                    <button
                      className="btn btn-success w-100 py-1 mt-2"
                      onClick={submit}
                      style={{
                        backgroundColor: "#00B53F",
                        border: "none",
                        height: "35px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        fontWeight: "500",
                      }}
                    >
                      <BsSend className="me-2" />
                      Request Call
                    </button>
                    <div
                      className="text-center text-muted mt-2"
                      style={{ fontSize: "11px" }}
                    >
                      By submitting this form, you agree to{" "}
                      <a href="#" className="text-primary text-decoration-none">
                        Terms of Use
                      </a>
                      .
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h1
                      style={{
                        color: "#4db749",
                      }}
                    >
                      Welcome to Peak Nest Murree – Your Luxury Escape in the
                      Hills
                    </h1>
                    <br />

                    <p>
                      Peak Nest Murree is a premium residential project designed
                      to offer a serene and luxurious lifestyle amidst the
                      natural beauty of Murree. Combining modern architecture
                      with breathtaking mountain views, Peak Nest is an ideal
                      destination for those seeking a peaceful retreat or a
                      high-end investment opportunity in one of Pakistan’s most
                      sought-after hill stations. The project provides a blend
                      of comfort, luxury, and nature, making it perfect for both
                      vacation homeowners and permanent residents
                      <br />
                      <br />
                      <h4 style={{ color: "#4db749" }} id="development">
                        Available Units at Peak Nest Murree
                      </h4>
                      <br />
                      <p>
                        Peak Nest offers spacious, elegantly designed
                        residential units tailored to modern lifestyles:
                      </p>
                      <ol class="custom-list">
                        <li>
                          <b>Studio Apartments:</b>
                          <br />
                          <ul>
                            <br />
                            <li>Sizes: 519 – 623 sq. ft.</li>
                            <li>Price Range: PKR 6,223,870 – 7,471,928</li>
                            <li>
                              Ideal for solo travelers, couples, or smart
                              investors.
                            </li>
                            <br />
                          </ul>
                        </li>

                        <li>
                          <b>One-Bed Apartments:</b>
                          <br />
                          <ul>
                            <br />
                            <li>Sizes: 822 – 957 sq. ft..</li>
                            <li>Price Range: PKR 11,514,433 – 13,391,994</li>
                            <li>
                              Perfect for small families or those seeking
                              comfort with a scenic view.
                            </li>
                            <br />
                          </ul>
                        </li>
                        <li>
                          <b>Penthouse:</b>
                          <br />
                          <ul>
                            <br />
                            <li>Size: 2250 sq. ft..</li>
                            <li>Price Range: 15,000 per sq. ft.</li>
                            <li>
                              Ideal for high-end buyers looking for a spacious,
                              luxurious residence in the hills.
                            </li>
                            <br />
                          </ul>
                        </li>
                      </ol>
                    </p>
                    {isExpanded && (
                      <p>
                        <h4 style={{ color: "#4db749" }}>
                          Why Invest in Peak Nest Murree?
                        </h4>
                        Before you explore further, here’s why Peak Nest Murree
                        is one of the most promising investment and lifestyle
                        destinations in Pakistan:
                        <ol>
                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Scenic Location with High Demand</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            Located in Mussiari, Murree, Peak Nest offers
                            unmatched views, fresh air, and a peaceful
                            ambiance—making it highly attractive for both
                            residents and tourists.
                          </p>
                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Modern Architecture in a Natural Setting</b>
                            </li>
                          </h5>
                          <br />
                          <p>
                            The design of Peak Nest reflects luxury and
                            functionality. Large windows, sleek finishes, and
                            open spaces ensure you enjoy both the indoors and
                            outdoors to the fullest.
                          </p>

                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Ideal for Investment or Vacation Living</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            Whether you're looking to earn rental income or
                            enjoy seasonal getaways, Peak Nest provides a
                            lucrative and luxurious opportunity in one of
                            Pakistan’s top hill station destinations.
                          </p>

                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Premium Amenities at Peak Nest Murree</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            Peak Nest offers a comprehensive lifestyle
                            experience with top-tier facilities designed for
                            your comfort and convenience:
                          </p>

                          <ol class="custom-list">
                            <li>Masjid for spiritual peace</li>
                            <li>
                              Children’s Play Area for family-friendly living
                            </li>
                            <li>On-site Restaurants for dining with a view</li>
                            <li>Shopping Centers for everyday convenience</li>
                            <li>24/7 Security for peace of mind</li>
                            <li>
                              Power Backup and Maintenance Management for
                              uninterrupted living
                            </li>
                            <li>Ample Parking for residents and guests</li>
                          </ol>
                        </ol>
                        <h3
                          style={{
                            color: "#4db749",
                            fontsize: "30px",
                          }}
                        >
                          Marketed & Developed by Trusted Names
                        </h3>
                        <br />
                        <h3>Developed By:</h3>
                        <p>
                          7 Sky Builders – Known for their solid track record in
                          premium real estate projects across Pakistan.
                        </p>
                        <br />
                        <h3>Marketed By:</h3>
                        <p>
                          7 Makkaan.com – Your reliable partner for secure and
                          transparent property investment.
                        </p>
                        <br />
                        <p>
                          Don’t miss the chance to own a piece of Murree’s
                          charm. Whether it's your dream vacation home or your
                          next big investment, Peak Nest Murree is where luxury
                          meets nature. Call us today or visit{" "}
                          <a href="https://www.makkaan.com/" target="_blank">
                            {" "}
                            Makkaan.com
                          </a>{" "}
                          to learn more about payment plans, unit availability,
                          and booking options.
                        </p>
                        <div></div>
                      </p>
                    )}
                    <a
                      onClick={toggleReadMore}
                      style={{ color: "green", cursor: "pointer" }}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </a>

                    <div id="development"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5" ref={developmentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="read-more-container">
                <h2
                  style={{
                    color: "#4db749",
                    fontWeight: "bold",
                    fontSize: "22px",
                  }}
                >
                  Development Updates for Peak Nest Murree
                </h2>

                <div className="row">
                  {/* Timeline first */}
                  <div className="col-12">
                    <div className="timeline">
                      {stages.map((stage, index) => (
                        <div key={stage.id} className="timeline-stage">
                          <div
                            className={`circle ${
                              activeStage === stage.id ? "active" : ""
                            }`}
                            onClick={() => setActiveStage(stage.id)}
                          >
                            <>
                              {stage.label.split(" ")[0]} <br />
                              {stage.label.split(" ")[1]}
                            </>
                          </div>
                          {index < stages.length - 1 && (
                            <div className="line"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Images second */}
                  <div className="col-12 mt-4">
                    <div className="timeline-images">
                      {stages
                        .filter((stage) => stage.id === activeStage)
                        .map(
                          (stage) =>
                            stage.images.length > 0 && (
                              <img
                                key={stage.id}
                                src={stage.images[0]} // Only the first image
                                alt={`${stage.label}-preview`}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  marginBottom: "20px",
                                  cursor: "pointer",
                                  objectFit: "cover",
                                  borderRadius: "10px",
                                }}
                                onClick={() => handleImageClick(stage.id)}
                              />
                            )
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Image Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: "hidden" }}>
              {modalImages && modalImages.length > 1 ? (
                <Swiper
                  key={showModal ? "open" : "closed"}
                  modules={[Navigation, Pagination]}
                  spaceBetween={0}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                  navigation
                  observer={true}
                  observeParents={true}
                  style={{ width: "100%", height: "auto" }}
                >
                  {modalImages.map((image, index) => (
                    <SwiperSlide key={index}>
                      <img
                        loading="lazy"
                        src={image}
                        alt={`Avenue18-development-${index}`}
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                modalImages?.length === 1 && (
                  <img
                    loading="lazy"
                    src={modalImages[0]}
                    alt="Avenue18-development"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                )
              )}
            </Modal.Body>
          </Modal>
          <div id="location"></div>
        </div>

        <div className="container mt-5" ref={locationRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Location
                    </h2>

                    <div className="row mt-3">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.647102671812!2d73.39469917442348!3d33.872984527176584!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfd99ce01d0aa9%3A0xe4c0908c01502006!2sPeak%20Nest%20Murree!5e0!3m2!1sen!2s!4v1736159045407!5m2!1sen!2s"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Map"
                      ></iframe>
                      <div id="payment"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5" id="payment" ref={paymentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Payment Floor plans For Peak Nest Murree
                    </h2>

                    <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div className="card" style={{ width: "100%" }}>
                          <div className="row">
                            <a
                              href={paymentplan}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                loading="lazy"
                                src={PN}
                                className="card-img-top"
                                alt="Avenue18-paymentplan"
                                style={{ padding: "10px", borderRadius: "5px" }}
                              />
                            </a>
                            <div className="card-body">
                              <p className="card-text">Peaknest Payment Plan</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div className="card" style={{ width: "100%" }}>
                          <a
                            href={paymentplanupdated}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              loading="lazy"
                              src={PNPP}
                              className="card-img-top"
                              alt="Peaknest-floorplan"
                              style={{ padding: "10px", borderRadius: "5px" }}
                            />
                          </a>
                          <div className="card-body" id="FAQ's">
                            <p className="card-text">Peaknest Floor plans</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-3" ref={paymentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="col-12">
                <div className="read-more-container">
                  <h2
                    style={{
                      color: "#4db749",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    FAQ's
                  </h2>

                  <div class="accordion mt-3" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Q1: What types and sizes of residential units are
                          available at Peak Nest Murree?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Peak Nest offers Studio and One-Bed apartments.
                          Studio sizes range from 519 to 623 sq. ft., while
                          One-Bed apartments range from 822 to 957 sq. ft.,
                          catering to both investors and end-users.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefour"
                          aria-expanded="false"
                          aria-controls="collapsefour"
                        >
                          Q2: Where is Peak Nest located?
                        </button>
                      </h2>
                      <div
                        id="collapsefour"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Peak Nest is located in Mussiari, Murree — offering
                          a premium lifestyle surrounded by scenic mountain
                          views.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          Q3: What amenities are available at Peak Nest Murree?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Peak Nest features a masjid, children's play area,
                          restaurants, shopping centers, 24/7 security, power
                          backup, dedicated parking, and professional
                          maintenance management.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="marketed">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          Q4: Is Peak Nest suitable for vacation homes or
                          investment purposes?
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Absolutely. Designed for comfort and luxury, Peak
                          Nest is perfect for vacation homeowners seeking peace
                          or investors looking for a high-return opportunity in
                          Murree.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="marketed">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          Q5: How can I book an apartment at Peak Nest Murree?
                        </button>
                      </h2>
                      <div
                        id="collapseSeven"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Simply fill out the enquiry form with your name,
                          city, phone number, and message — or contact
                          Makkaan.com to secure your serene mountain escape
                          today.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-3 mt-3">
          <div className="row">
            <div className="col-md-6 mb-3">
              <div
                className="card"
                style={{
                  minHeight: isExpandedMarketedBy ? "auto" : "250px",
                  transition: "min-height 0.3s ease",
                }}
              >
                <div className="row g-0">
                  <div className="col-md-4 d-flex justify-content-center">
                    <img
                      loading="lazy"
                      src={makkaanLogo}
                      className="img-fluid rounded-start"
                      alt="Makkaan-logo"
                      style={{
                        width: "200px",
                        height: "150px",
                        padding: "15px",
                        marginTop: "25px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h3 className="card-title">Marketed By</h3>
                      <h5 className="card-title">Makkaan.com</h5>
                      <p>
                        Makkaan.com is a trustworthy and responsible platform
                        that aims to provide you with all the Residential,
                        Commercial, and Investment details under the same roof.
                        The only podium that offers reliable services to
                        investors, dealers, societies,
                      </p>
                      {isExpandedMarketedBy && (
                        <p>
                          and end-users of the real estate world throughout the
                          country. We use an all-inclusive marketing strategy
                          that covers all aspects of projects and helps
                          investors at every stage of the process with complete
                          transparency.
                        </p>
                      )}
                      <a
                        onClick={toggleMarketedBy}
                        style={{ color: "green", cursor: "pointer" }}
                      >
                        {isExpandedMarketedBy ? "Read Less" : "Read More"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <div
                className="card"
                style={{
                  minHeight: isExpandedDevelopedBy ? "auto" : "250px",
                  transition: "min-height 0.3s ease",
                }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      loading="lazy"
                      src={developerlogo}
                      className="img-fluid rounded-start"
                      alt="Avenue18-logo"
                      style={{
                        width: "200px",
                        height: "150px",
                        padding: "15px",
                        marginTop: "25px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h3 className="card-title">Developed By</h3>
                      <h5 className="card-title">7 SKy Builders</h5>
                      <p>
                        Peak Nest Murree is developed by 7 SKy Builders, a
                        reputed real estate developer with a strong track record
                        of delivering successful projects across Pakistan
                      </p>
                      {isExpandedDevelopedBy && (
                        <p>
                          Peak Nest Murree is developed by 7 SKy Builders, a
                          reputed real estate developer with a strong track
                          record of delivering successful projects across
                          Pakistan. 7Sky’s projects are a testament to their
                          commitment to innovation and excellence. 201
                          Apartments is one of their projects, located at
                          Expressway Murree has already been successfully
                          completed, showcasing their ability to deliver
                          high-quality results.
                        </p>
                      )}
                      <a
                        onClick={toggleDevelopedBy}
                        style={{ color: "green", cursor: "pointer" }}
                      >
                        {isExpandedDevelopedBy ? "Read Less" : "Read More"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Peaknest;
